import * as React from "react";
import {Field} from "react-final-form";
import {EstadosTarea as estadosTareas} from "../modelo/EstadosTarea";

export default class EstadosTarea extends React.Component<EstadosTareaProps> {

    render() {
        const {className} = this.props;
        return (
            <Field name={this.props.name}>
                {({input, meta}) => (
                    <div>
                        <select {...input} className={className ? className.concat(" form-control") : "form-control"}>
                            <option value={""}>Selecciona...</option>
                            {estadosTareas.map(estado => {
                                return <option key={estado} value={estado}>{estado}</option>;
                            })}
                        </select>
                        <div>
                            {meta.error && <span className={"text-danger"}>{meta.error}</span>}
                        </div>
                    </div>
                )}
            </Field>
        );
    }

}

interface EstadosTareaProps {
    name: string,
    className?: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/bandeja/componentes/EstadosTarea.tsx